import React from 'react'
import CustomTheme from './CustomTheme'
import Typography from '@mui/material/Typography'

const Tip = React.forwardRef((props, ref) => {
    return(
        <p id={props.id} ref={ref} className={`fyw-font-tip ${props.className}`} style={props.style} onClick={props.onClick !== null ? props.onClick:null}>
            {props.children}
        </p>
    )
})

const Text = React.forwardRef((props, ref) => {
    return(
        <CustomTheme>
        <Typography id={props.id} ref={ref} className={props.className} {...props}>
            {props.children}
        </Typography>
        </CustomTheme>
    )
})

const Paragraph = React.forwardRef((props, ref) => {
    return(
        <CustomTheme>
            <Typography 
                id={props.id} 
                ref={ref} 
                className={props.className} 
                sx={{
                    color: 'primary.dark',
                    // ...props.sx
                }}
                {...props}
            >
                {props.children}
            </Typography>
        {/*<article id={props.id} ref={ref}>
                <p className={`fyw-paragraph ${props.className}`} style={props.style}>
                    {props.children}
                </p>
        </article>*/}
        </CustomTheme>
    )
})

const Title = React.forwardRef((props, ref) => {
    return(
        <h1 id={props.id} ref={ref} className={`fyw-title text-center ${props.className}`}>
            {props.children}
        </h1>
    )
})

const Subtitle = React.forwardRef((props, ref) => {
    return(
        <h1 id={props.id} ref={ref} className={`fyw-subtitle-dark text-center ${props.className ? props.className : ''}`}>
            {props.children}
        </h1>
    )
})

export { Tip, Text, Title, Subtitle, Paragraph }